/*
 Copyright 2019-present wobe-systems GmbH

 Licensed under the Apache License, Version 2.0 (the 'License');
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an 'AS IS' BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
import { MutationTree } from 'vuex';
import * as types from '@/store/types';
import {
  UserState, LoginUser, User, FlowOwner, Gravatar,
} from './models';

export const mutations: MutationTree<UserState> = {
  [types.MUTATE_USER_LOGIN](state, payload: LoginUser) {
    if (payload.success) {
      state.user = payload.user;
      state.loginState = payload.success;
    }
    state.loginState = payload.success;
  },

  [types.MUTATE_USER_LOGOUT](state, isLogout: LoginUser) {
    if (isLogout) {
      state.user = {
        id: '',
        email: '',
        password: '',
        username: '',
        isAdmin: false,
        isAllowedToUpload: false,
      };
      state.loginState = false;
    }
  },

  [types.MUTATE_REMOVE_USER_STATE](state) {
    state.user = {
      id: '',
      email: '',
      password: '',
      username: '',
      isAdmin: false,
      isAllowedToUpload: false,
    };
    state.loginState = false;
  },

  [types.MUTATE_USER](state, payload: User) {
    if (payload) {
      state.user = payload;
    }
  },

  [types.MUTATE_FLOW_OWNER](state, payload: FlowOwner) {
    const ownerFound = state.flowOwners.find((owner) => owner.id === payload.id);
    if (!ownerFound) {
      state.flowOwners.push(payload);
    }
  },

  [types.MUTATE_USERS](state, payload: User[]) {
    if (payload) {
      state.users = payload;
    }
  },

  [types.MUTATE_USERS_UPDATED](state, payload: User) {
    const index = state.users.findIndex((u) => u.id === payload.id);

    if (index !== -1) {
      state.users.splice(index, 1, payload);
    }
  },
  [types.MUTATE_USERS_ADMIN_RIGHT](state, payload: any) {
    const index = state.users.findIndex((u) => u.id === payload.id);

    if (index !== -1) {
      state.users[index].isAdmin = payload.isAdmin;
    }
  },
  [types.MUTATE_USERS_UPLOAD_RIGHT](state, payload: any) {
    const index = state.users.findIndex((u) => u.id === payload.id);

    if (index !== -1) {
      state.users[index].isAllowedToUpload = payload.isAllowedToUpload;
    }
  },

  [types.MUTATE_SIGNUP_REQUEST](state, payload: boolean) {
    state.isSignupRequested = payload;
  },

  [types.MUTATE_FORGET_PASSWORD_REQUEST](state, payload: boolean) {
    state.isForgetPassRequested = payload;
  },

  [types.MUTATE_GRAVATARS](state, gravatar: Gravatar) {
    if (state.gravatars.find((g) => g.email === gravatar.email)) {
      return;
    }
    state.gravatars = [...state.gravatars, gravatar];
  },
};
